import { render, staticRenderFns } from "./AppCheckboxGroup.vue?vue&type=template&id=558618de&scoped=true&"
import script from "./AppCheckboxGroup.vue?vue&type=script&lang=js&"
export * from "./AppCheckboxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558618de",
  null
  
)

export default component.exports